import React from 'react'
import Wrapper from './layout/Wrapper'
import styled from 'styled-components'

const P = styled.p`
  color: ${p => p.theme.grisOscuro};
  margin: 40px 0;

  strong {
    color: #000;
  }
`;

export default () => (
  <Wrapper>
    <P>
      <strong>IMPORTANTE:</strong> BAC Credomatic informa a todos sus clientes titulares de tarjetas VISA y
      MasterCard que las mismas ya no ofrecerán el beneficio de Seguro de
      Accidente de Viaje. El cambio es una decisión de ambas marcas, ajeno a
      nuestro ámbito de acción. Recordamos a nuestros clientes que pueden usar
      nuestros canales de comunicación para atender cualquier inquietud o
      consulta en relación con el tema.
    </P>
  </Wrapper>
);